import { combineReducers } from "redux";
import authReducer from "./authReducers";
import ruleReducer from "./ruleReducers";
import userReducer from "./userReducers";
import locationReducer from "./locationReducers";
import attendanceReducer from "./attendanceReducers";
import dashboardReducer from "./dashboardReducers";
import holidayReducer from "./holidayReducers";
import accessReducer from "./accessReducers";
import hrReducer from "./hrReducers";
import reportingReducer from "./reportingReducer";
import queryReducer from "./queryReducers";
import dprReducer from "./dprReducers";
import canteenReducer from "./canteenReducers";

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  rule: ruleReducer,
  location: locationReducer,
  attendance: attendanceReducer,
  dashboard: dashboardReducer,
  access: accessReducer,
  holiday: holidayReducer,
  hr: hrReducer,
  reporting: reportingReducer,
  query: queryReducer,
  dpr: dprReducer,
  canteen: canteenReducer
});
